import { gql } from '@apollo/client';

export type StaffSmsRecipient = {
  id: string;
  name: string;
  phoneNumber: string | null;
  source: 'ENROLLED' | 'PROCEDURE' | 'OR';
};

export type StaffSmsPreview = {
  procedureId: number;
  patientName: string;
  procedureName: string;
  message: string;
  recipients: StaffSmsRecipient[];
};

export type StaffSmsResult = { recipientId: string; accepted: boolean };

export const staffSmsPreview = gql`
  query PreOpBoardStaffSmsPreview($patientId: Long!) {
    preview: preOpBoardStaffSmsPreview(patientId: $patientId) {
      procedureId
      patientName
      procedureName
      message
      recipients {
        id
        name
        phoneNumber
        source
      }
    }
  }
`;

export const sendStaffSms = gql`
  mutation SendPreOpBoardStaffSms(
    $patientId: Long!
    $procedureId: Long!
    $recipientIds: [String!]!
    $expectedMessage: String!
  ) {
    results: sendPreOpBoardStaffSms(
      patientId: $patientId
      procedureId: $procedureId
      recipientIds: $recipientIds
      expectedMessage: $expectedMessage
    ) {
      recipientId
      accepted
    }
  }
`;
